import { component as defineComponent } from 'flightjs';

export default defineComponent(function() {
    this.attributes({
        label: '[data-toggle-label]',
        pill: '[data-toggle-pill]',
    });

    this.after('initialize', function() {
        this.on('click', this.triggerToggleAdvancedFilters);
        this.on(document, 'uiBrowseAdvancedFiltersExpanded', this.changeToHideFiltersLabel);
        this.on(document, 'uiBrowseAdvancedFiltersCollapsed', this.changeToShowFiltersLabel);
        this.on(document, 'dataContestsWillLoad', this.updatePillDisplay);
    });

    this.isAdvancedFilterApplied = function(url) {
        var advancedFilters = this.$node.attr('data-advanced-filters-toggle').split(' ');

        url = url || window.location.search;

        for (var i in advancedFilters) {
            if (
                decodeURIComponent(url).match(
                    new RegExp('[\\?&]+' + advancedFilters[i] + '\\[?\\]?=')
                )
            ) {
                return true;
            }
        }
        return false;
    };

    this.showPill = function() {
        this.select('pill').removeAttr('data-hidden');
    };

    this.hidePill = function() {
        this.select('pill').attr('data-hidden', true);
    };

    this.updateLabel = function(text) {
        if (text) {
            this.select('label').text(text);
        }
    };

    this.updatePillDisplay = function(e, data) {
        if (data && data.url && this.isAdvancedFilterApplied(data.url)) {
            this.showPill();
        } else {
            this.hidePill();
        }
    };

    this.triggerToggleAdvancedFilters = function() {
        this.trigger('uiAdvancedFiltersToggleRequested');
    };

    this.changeToHideFiltersLabel = function() {
        this.select('label').attr('data-active', true);
        this.updateLabel(this.$node.attr('data-text-hide'));
    };

    this.changeToShowFiltersLabel = function() {
        this.select('label').removeAttr('data-active');
        if (this.isAdvancedFilterApplied()) {
            this.updateLabel(this.$node.attr('data-text-edit'));
        } else {
            this.updateLabel(this.$node.attr('data-text-show'));
        }
    };
});



// WEBPACK FOOTER //
// ./src/web/js/browse/ui/toolbar-toggle.js